import { Component, Input, OnInit } from '@angular/core';
import { ITaskForm } from '../task-form/task-form.component';

@Component({
  selector: 'app-card-task',
  templateUrl: './card-task.component.html',
  styleUrls: ['./card-task.component.sass']
})
export class CardTaskComponent implements OnInit {

  @Input('input') input: ITaskForm

  ui: ICardTaskInput = {} as ICardTaskInput

  constructor() { }

  ngOnInit(): void {
    if (!this.input)
      this.ui = placeholder
    else
      this.loadUI(this.input)
  }

  loadUI(task: ITaskForm) {
    this.ui.name = task.name
    this.ui.date = task.fixing_date
    this.ui.description = task.description
  }

}

const placeholder: ICardTaskInput = {
  id: 'thisisatest',
  name: 'Task 1',
  date: '2020-06-08',
  assignImgs: [
    'url(assets/images/avatar.png)',
    'url(assets/images/avatar.png)',
    'url(assets/images/avatar.png)'
  ],
  faciId: '#001',
  assetId: 'R0014',
  annotId: 'C05',
  taskStatus: 'Ongoing',
  supportDocs: 'Yes'
}

export interface ICardTaskInput {
  /** Task ID, not shown in the UI */
  id: string
  /** Task name */
  name: string
  /** Date */
  date: string
  /** Description */
  description?: string
  /** Assignees image URL */
  assignImgs?: string[]
  /** UNUSED - Facility ID */
  faciId?: string
  /** UNUSED - Asset ID */
  assetId?: string
  /** UNUSED - Annotation ID */
  annotId?: string
  /** UNUSED - Task status */
  taskStatus?: string
  /** UNUSED - Supporting Document */
  supportDocs?: string
}
